import React, { useState, createContext } from 'react';
import EnrollmentData from './EnrollmentData';

export const EnrollmentStateContext = createContext();

const EnrollmentContextProvider = ({ children }) => {
  const stateHook = useState({...EnrollmentData.INITIAL_STATE});

  return (
    <EnrollmentStateContext.Provider value={stateHook}>
      {children}
    </EnrollmentStateContext.Provider>
  );
};

export default EnrollmentContextProvider;